import axios from "axios";
import { toast } from "react-toastify";

const axiosInstance = axios.create();
let notificationQueue = [];

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const status = error.response?.status;
    const data = error.response?.data;
    if (status === 401) {
      try {
        notificationQueue.push({ type: "error", message: data?.error });
        setTimeout(() => {
          showNotifications();
        }, 4000);
        await new Promise((resolve) => setTimeout(resolve, 8000));
        localStorage.clear();
        toast.error("Session has expired! Please relogin")
        window.location.href = "/";
      } catch (navError) {
        console.error("Navigation to login failed:", navError);
      }
    } else
      if (status === 500) {
        notificationQueue.push({ type: "error", message: data?.error });
        setTimeout(() => {
          showNotifications();
        }, 5000);
      } else if (status === 400) {
        notificationQueue.push({ type: "error", message: data?.error });
        setTimeout(() => {
          showNotifications();
        }, 5000);
      }
      else if (status === 200) {
        notificationQueue.push({ type: "error", message: data?.error });
        setTimeout(() => {
          showNotifications();
        }, 5000);
      }

    return Promise.reject(error);
  }
);

function showNotifications() {
  if (notificationQueue?.length >= 1) {
    const uniqueErrorMessages = Array.from(
      new Set(notificationQueue.map((item) => item.message))
    );
    const firstErrorMessage = uniqueErrorMessages;
    toast.info(firstErrorMessage);
    notificationQueue = [];
  }
}

class HttpRequest {
  static async get(url) {
    try {
      const res = await axiosInstance({
        method: "GET",
        url,
      });
      return res.data;
    } catch (err) {
      return err;
    }
  }

  static async post(url, data) {
    try {
      const res = await axiosInstance({
        method: "POST",
        url,
        data,
      });

      return res.data;
    } catch (err) {
      console.error(err);
      return err;
    }
  }

  static async delete(url, data) {
    try {
      const res = await axiosInstance({
        method: "DELETE",
        url,
        data,
      });

      return res.data;
    } catch (err) {
      console.error(err.response);
      return err;
    }
  }

  static async update(url, data) {
    try {
      const res = await axiosInstance({
        method: "PATCH",
        url,
        data,
      });

      return res.data;
    } catch (err) {
      return err;
    }
  }

  static async upload(url, data) {
    try {
      const res = await axiosInstance({
        method: "POST",
        url,
        data,
      });

      return res.data;
    } catch (err) {
      return err;
    }
  }
}

export default HttpRequest;
